/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type AttachContractDocumentDetail = {
    id?: string;
    objectKey?: string;
    downloadUrl?: string;
    originalName?: string;
    fileExtension?: string;
    documentType?: AttachContractDocumentDetail.documentType;
};
export namespace AttachContractDocumentDetail {
    export enum documentType {
        CITIZEN_ID_CARD = 'CITIZEN_ID_CARD',
        FACEBOOK_SCREEN = 'FACEBOOK_SCREEN',
        PHOTO_WITH_CARD = 'PHOTO_WITH_CARD',
        MACHINE = 'MACHINE',
        OTHERS = 'OTHERS',
        GENERATED_CONTRACT = 'GENERATED_CONTRACT',
        SIGNED_CONTRACT = 'SIGNED_CONTRACT',
        REDEEM_DOCUMENT = 'REDEEM_DOCUMENT',
        ACCEPT_PAYMENT_DOCUMENT = 'ACCEPT_PAYMENT_DOCUMENT',
        FORCLOSURE_DOCUMENT = 'FORCLOSURE_DOCUMENT',
        PDPA_CONTRACT = 'PDPA_CONTRACT',
        BILL_CONTRACT = 'BILL_CONTRACT',
    }
}

